// Pretty labels for game keys and small helpers
export const GAME_LABELS = {
  'ea-fc': 'EA FC',
  'cod': 'COD',
  'cs-go': 'CS:GO',
  'mario-kart': 'Mario Kart',
  'clash-royale': 'Clash Royale',
  'valorant': 'Valorant',
};

export function formatGame(key = '') {
  const k = String(key).toLowerCase();
  if (GAME_LABELS[k]) return GAME_LABELS[k];
  // fallback: turn "some-game_key" into "Some Game Key"
  return k.replace(/[-_]+/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

export function formatDate(iso) {
  return iso ? new Date(iso).toLocaleDateString() : 'TBA';
}

export function formatPrize(v) {
  return v || 'TBD';
}

